var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { get } from '../../utils/themeGet';
const InfoCircleIcon = (_a) => {
    var { size = 'medium', color = 'inherit' } = _a, rest = __rest(_a, ["size", "color"]);
    const props = Object.assign(Object.assign({}, rest), { color });
    const sizePx = Number.isFinite(size)
        ? size
        : get(`iconSizes.${size}`)(props) || get('iconSizes.medium')(props);
    return (React.createElement("svg", Object.assign({}, props, { width: sizePx, height: sizePx, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("path", { d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm1 6.4v6h-2v-6h2zm-1-3.6a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z", fill: "currentColor" })));
};
export default InfoCircleIcon;
